var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 80",
    width: 240,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "textShadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 1,
    stdDeviation: 1,
    floodColor: "black",
    floodOpacity: 0.7
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontSize: 60,
    filter: "url(#textShadow)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    fill: "white"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    fill: "red"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    fill: "white"
  }, "tU"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.5c3374c8f83f910a5151d9daa82d9ac2.svg";
export { ForwardRef as ReactComponent };